import { objectIsEmpty } from 'utils/Client/storeUtils'
import { handleAuthError } from 'utils/Client/apiErrorHandler'
import { setBugsnagUser } from 'bugsnag'
import * as paths from 'utils/Client/urlPaths'
import {
  handleOverviewPage,
  handlePortfolioPage,
  handleDocumentsPage,
  handleUploaderPage,
  handleProfileSettingsPage,
  setLoginToken
} from 'routing/thunks/client'
import { getUser, revokeAuthTokens } from 'utils/Client/apiRequest'
import { redirectIfUnauthorized, isRouteAllowed } from 'utils/Client/authorization'
import actions from 'actions/index'
import { trackAnalyticsEvent } from 'analytics'

const {
  setUser,
  setIsInitialLoad,
  setIsLoading,
  setAppType
} = actions

const setLoadingStates = (dispatch, getState)  => {
  const {
    redirection: { isRedirected }
  } = getState()

  if (!isRedirected) {
    dispatch(setIsInitialLoad(false))
    dispatch(setIsLoading(false))
  }
}

const callThunkIfAuthorized = async (userData, dispatch, getState, wrappedThunk, type, payload) => {
  if (!objectIsEmpty(userData)) {
    const { onlineExperienceType } = userData

    await redirectIfUnauthorized(onlineExperienceType, type, payload)
    if (isRouteAllowed(onlineExperienceType, type, payload)) {
      await wrappedThunk(dispatch, getState)
    }
  }
}

export const authorizationHelper = async (...args) => {
  const [wrappedThunk, dispatch, getState, action] = args
  const { user: { user } } = getState()
  const { action: { type, payload } } = action
  let finalUserData = user

  dispatch(setIsLoading(true))

  try {
    if (objectIsEmpty(user)) {
      const userData = await getUser()

      if (userData) {
        finalUserData = userData.data.attributes
        const {
          id,
          attributes: {
            canonicalUserId,
            onlineExperienceType
          }
        } = userData.data


        trackAnalyticsEvent(`Online Experience Type ${onlineExperienceType}`)
        trackAnalyticsEvent(`Canonical user ID  ${canonicalUserId}`)

        dispatch(setAppType(onlineExperienceType.toLowerCase()))
        dispatch(setUser(finalUserData))
        setBugsnagUser(id, canonicalUserId)
      }
    }
    await callThunkIfAuthorized(finalUserData, dispatch, getState, wrappedThunk, type, payload)
    setLoadingStates(dispatch, getState)
  } catch (e) {
    handleAuthError(e, revokeAuthTokens)
  }
}

export const authorizationHandler = (...args) => (
  authorizationHelper.bind(null, ...args)
)

export default {
  CLIENT_LOGIN: {
    path: paths.CLIENT_LOGIN,
    thunk: setLoginToken
  },
  CLIENT_OVERVIEW: {
    path: paths.CLIENT_OVERVIEW,
    thunk: authorizationHandler(handleOverviewPage)
  },
  CLIENT_PORTFOLIO: {
    path: paths.CLIENT_PORTFOLIO,
    thunk: authorizationHandler(handlePortfolioPage)
  },
  CLIENT_DOCUMENTS: {
    path: paths.CLIENT_DOCUMENTS,
    thunk: authorizationHandler(handleDocumentsPage)
  },
  CLIENT_UPLOADER: {
    path: paths.CLIENT_UPLOADER,
    thunk: authorizationHandler(handleUploaderPage)
  },
  CLIENT_PROFILE_SETTINGS: {
    path: paths.CLIENT_PROFILE_SETTINGS,
    thunk: authorizationHandler(handleProfileSettingsPage)
  }
}



// WEBPACK FOOTER //
// ./src/routing/routesMap/client.js